import { HttpHeaders } from '@angular/common/http';

export class AbmPoint2 {
    constructor(
        public x: number = 0,
        public y: number = 0,
    ) {
    }
}

export class AbmPoint3 {
    constructor(
        public x: number = 0,
        public y: number = 0,
        public z: number = 0,
    ) {
    }
}

export enum AbmHttpMethod {
    NOT_SUPPORTED,
    GET,
    POST,
    PUT,
    DELETE,
}

export enum BarType {
    BAR_SINGLE_Y_AXIS,
    BAR_DOUBLE_Y_AXIS,
    BAR_ON_X_AXIS,
}

export enum AbmEquipStatusEnum {
    NORMAL = 0,
    ERROR = 1,
    OFFLINE = 2,
    WARN = 3,
}

// digitalshow组件数据类
export class DigitalShowData {
    constructor(
        public title: string,
        public num: number,
        public units: string,
        public isLink?: boolean
    ) { }
}

export class LogoData {
    constructor(
        public cnTitle: string,
        public enTitle: string,
        public imgSrc?: string,
    ) { }
}

export class AbmButtonGroup {
    public label: string;
    public idx: number;
    constructor(
        public labels: string[],
        public defaultLabelIdx = 0,
    ) {
        if (defaultLabelIdx < 0 || defaultLabelIdx > labels.length - 1) {
            throw new Error('Invalid index:' + defaultLabelIdx);
        } else {
            this.label = labels[defaultLabelIdx];
            this.idx = defaultLabelIdx;
        }
    }

    public nextLabel(): string {
        this.idx = (this.idx === this.labels.length - 1 ? 0 : this.idx + 1);
        this.label = this.labels[this.idx];
        return this.label;
    }
}

export class AbmButtonWithLink {
    constructor(
        public label: string,
        public link?: string,
        public icon?: string,
        public index?: number,
    ) { }
}

export class NameValue {
    constructor(
        public name: string,
        public value: number | string | boolean,
    ) { }
}

export class AbmListData {
    constructor(
        public data: Array<Array<number | string>>,
        public headers?: Array<string>,
    ) { }
}

export interface AbmEchartsConfig {
    /**
     * 是否显示 tooltip，有时在大屏操作时不需要显示 tooltip
     */
    showToolTip: boolean;
    /**
     * ECharts 主题名称，可以是一个或者多个。从 assets/echarts/theme 目录加载 <theme name>.json
     */
    themes: string | string[];
    /**
     * 是否使用地图，如果使用，则会加载城市数据。
     */
    useMap: boolean;
}

export class AbmLineData {
    constructor(
        public legend: Array<string>,
        public data: Array<Array<number>>,
        public xAxis: Array<any>,
    ) {
        if (legend && data && legend.length !== data.length) {
            throw new Error('category length and data length are inconsistent');
        }
    }
    get length(): number { return this.legend ? this.legend.length : 0; }
}

export class AbmBarData {
    constructor(
        public categories: Array<any>,
        public data: Array<Array<any>>,
        public legend?: Array<string>,
    ) { }
}

export class AbmScatterData {
    constructor(
        public x: number | string,
        public y: number | string,
        public value: number,
        public value2?: string | number,
        public value3?: string | number,
        public value4?: string | number,
        public value5?: string | number,
    ) { }

    public unzip(): Array<string | number> {
        const ret = [this.x, this.y, this.value];
        if (this.value2) { ret.push(this.value2); }
        if (this.value3) { ret.push(this.value3); }
        if (this.value4) { ret.push(this.value4); }
        if (this.value5) { ret.push(this.value5); }
        return ret;
    }
}

export class AbmDataMapping {
    constructor(
        public name: string,
        public source: string[],
        public target: string[],
    ) {
        if (source.length !== target.length) {
            throw new Error('data mapping length inconsistent:' + source.toString() + target.toString());
        }
    }
}

export class AbmFrameData {
    constructor(
        public title: string,
        public options: any,
        public buttons?: AbmButtonWithLink[],
        public subTitle?: string,
    ) { }
}

export class AbmFrameDataCache {
    public disablePageBtn: [boolean, boolean];
    public currentSlice: number;
    public sliceCount = 0;
    constructor(
        public data: Array<any>,
        public numPerSlice?: number,
    ) {
        this.disablePageBtn = [true, false];
        if (numPerSlice) {
            this.sliceCount = Math.ceil(data.length / numPerSlice);
        }
        if (this.sliceCount < 2) {
            this.disablePageBtn = [true, true];
        }
    }
}

export class AbmRequestLink {
    public name: string;
    constructor(
        public indexName: string,
        public endpoint: string,
        public method = AbmHttpMethod.GET,
        public mockFile?: string,
        public header?: HttpHeaders,
        public replaceBodyWithParam = false,
    ) {
        this.name = endpoint.split('/').pop();
    }

    public setName(name: string): AbmRequestLink {
        this.name = name;
        return this;
    }
}

export class AbmResponseData {
    constructor(
        public code: number,
        public success: boolean,
        public msg: string,
        public data: any,
    ) { }
}

export enum AbmUserAction {
    BUTTON = 'BUTTON',
    PAGE = 'PAGE',
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
}

export class AbmUserBehavior {
    constructor(
        public userName: string,
        public actionType: AbmUserAction,
        public actionName: string,
        public ua: string,
    ) { }
}

export class AbmUser {
    public name: string;
    public password: string;
    public rememberMe: boolean;
    public id: number | string;
    public token: string;
    private _tokenExpire: Date;

    constructor(name: string = null, password: string = null, rememberMe?: boolean) {
        this.password = password;
        this.name = name;
        this.rememberMe = (rememberMe !== null && rememberMe);
    }

    public init(name: string = null, password: string = null) {
        this.name = name;
        this.password = password;
    }

    set tokenExpireStr(expire: string) {
        this._tokenExpire = new Date(expire);
    }

    get tokenExpireStr() { return this._tokenExpire.toISOString(); }

    get tokenExpire() { return this._tokenExpire; }

    get rememberMeStr() { return this.rememberMe ? 'true' : 'false'; }

    set rememberMeStr(rememberMe: string) {
        this.rememberMe = (rememberMe && rememberMe === 'true');
    }

}
